import {
  FETCH_INVESTORS,
  FetchInvestorsAction,
  RESET_DATA_INVESTORS,
  UPDATE_INVESTORS,
  SELECTED_LINKED_ACCOUNT,
  selectedLinkedAccountAction
} from '../../actions/investor/fetchInvestors';
import { IInvestorsReport, Investor } from '../../../types/investorTypes';
import { PaginationInfo } from '../../../types/sharedTypes';
import {
  FetchInvestorsReportAction,
  FETCH_INVESTORS_REPORT
} from '../../../components/administrator/investorsReport/fetchInvestorsReport';
import { IPrecalcFees, PrecalcFeesLoadedAction, PRECALC_FEES_LOADED } from '../../actions/investor/fetchInvestorsPrecalcFees';

export interface InvestorsState {
  investors: Array<Investor>;
  investorsReport: Array<IInvestorsReport>;
  precalcFeesState: IPrecalcFees;
  paginationInfo: PaginationInfo;
  isSelected: boolean;
}

const initialState: InvestorsState = {
  investors: [],
  investorsReport: [],
  precalcFeesState: {} as IPrecalcFees,
  paginationInfo: new PaginationInfo(),
  isSelected: false
};

const investorsReducer = (
  state: InvestorsState = initialState,
  action: FetchInvestorsAction & selectedLinkedAccountAction & FetchInvestorsReportAction & PrecalcFeesLoadedAction
): InvestorsState => {
  switch (action.type) {
    case FETCH_INVESTORS:
      return {
        ...state,
        investors: action.investors,
        paginationInfo: action.paginationInfo
      };
    case RESET_DATA_INVESTORS:
      return {
        ...state,
        investors: [],
        paginationInfo: new PaginationInfo(),
        isSelected: false
      };
    case UPDATE_INVESTORS:
      return {
        ...state,
        investors: [...action.investors]
      };
    case SELECTED_LINKED_ACCOUNT:
      return {
        ...state,
        isSelected: action.isSelected
      };
    case FETCH_INVESTORS_REPORT:
      return {
        ...state,
        investorsReport: action.investorsReport,
        paginationInfo: action.paginationInfo
      };
    case PRECALC_FEES_LOADED:
      return {
        ...state,
        precalcFeesState: action.precalcFeesState
      };
    default:
      return state;
  }
};

export default investorsReducer;
